'use client';

import {
  accountsloginFn,
  type DefaultQueryError,
  type LoginRequestBody,
  type LoginResponse,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useLoginMutation = (
  opts?: UseMutationOptions<LoginResponse, DefaultQueryError, LoginRequestBody>
) =>
  useMutation<LoginResponse, DefaultQueryError, LoginRequestBody>({
    mutationFn: accountsloginFn,
    ...opts,
  });
